var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('editor',{ref:"editor",attrs:{"initialValue":_vm.internal,"height":_vm.height + 'px',"options":_vm.mdConfig,"initialEditType":"wysiwyg"},on:{"change":_vm.update}})}
var staticRenderFns = []

export { render, staticRenderFns }